<template>
  <div>
    <multiselect class="multiselector"
      v-model="selectedOption"
      :options="listOptions"
      :label="listLabel"
      :track-by="listValue"
      placeholder=""
      :clear-on-select="true"
      :show-labels="false"
      :multiple="false"
    />
  </div>
</template>

<!-- TODO: Look into making service that takes care of all different selects -->
<!-- and turning all these into one sole component: FormResponseDropdowns.vue -->

<script>
  import Multiselect from 'vue-multiselect'
  import axios from 'axios'
  import GlobalEventBus from '@services/GlobalEventBus'
  import ModalService from '@services/ModalService'
  // import TrainingCenter from '@models/TrainingCenter'
  // import SerializedResponse from '@services/SerializedResponse'

  export default {
    name: 'searchable-select',
    components: {
      Multiselect,
    },
    data () {
      return {
        selectedOption: this.value ? this.value : null,
        listOptions: JSON.parse(this.options),
        listLabel: this.labelName ? this.labelName : 'name',
        listValue: this.valueName ? this.valueName : 'id',
      }
    },
    mounted () {
      console.log('props', this.$props)
      GlobalEventBus.subscribe('clear-fields', e => {
        this.selectedOption = null
        GlobalEventBus.dispatch('determine-location', false)
      })

      GlobalEventBus.subscribe(this.toClear, e => {
        this.selectedOption = null
      })

      if (this.listenFor) {
        GlobalEventBus.subscribe(this.listenFor, items => {
          this.getNewOptions(this.listenFor, items)
        })
      }

      if (this.raiseOnChange == "paul-change" && this.formType != 'dmd-phase' && this.formType != 'task') {
        this.fetchTimothies(this.value)
        this.fetchReport(this.value)
      }
    },
    computed: {
    },
    methods: {
      setNewValue(newValue){
        var el = document.getElementById(this.hiddenElement)
        if (el && this.raiseOnChange != "paul-change"){
          el.value = newValue[this.$data.listValue]
        }

        if (this.raiseOnChange && this.raiseOnChange != "training-center-group-change" && this.raiseOnChange != "paul-change") {
          this.fetchTcgsForCountry(newValue)
            .then(resp => {
              GlobalEventBus.dispatch(this.raiseOnChange, resp.data)

              gon.location = null

              // determine if we should allow location information to be displayed based on country restrictions
              GlobalEventBus.dispatch('determine-restriction', newValue.restricted)

              // Dispatch event to determine which location elements to use
              GlobalEventBus.dispatch('determine-location', newValue)
              GlobalEventBus.dispatch('tcg-clear', true)
              GlobalEventBus.dispatch('paul-clear', true)
            })


          if (this.formType === 'task') {
            this.fetchLeadersForCountry(newValue)
              .then(resp => {
                let leadersDropdownElem = document.getElementById("leader-dropdown")
                let i = null 
                let len = leadersDropdownElem.options.length - 1
                for(i = len; i >= 0; i--) {
                  leadersDropdownElem.remove(i)
                }
                
                leadersDropdownElem.add(new Option(), undefined)
                resp.data.forEach(el => {
                  leadersDropdownElem.add(new Option(`${el.first_name} ${el.last_name}`, el.id), undefined)
                })
              })
          }

        } else if (this.raiseOnChange == "paul-change") {
          if (this.formType != 'dmd-phase' && this.formType != 'task') {
            this.fetchTimothies(newValue)
            this.fetchReport(newValue)

            gon.tims_present = null
          }
          if (this.formType == 'tcv') { 
            // check for too many visits to TrainingCenter
            this.getTCVisits(newValue.training_center_id) 
          }
      
          let hiddenTrainingCenterId = document.getElementById('hidden-tc-id')
          hiddenTrainingCenterId.value = newValue.training_center_id

          let hiddenTrainingCenterPersonId = document.getElementById('hidden-p-id')
          hiddenTrainingCenterPersonId.value = newValue.id

        } else if (this.raiseOnChange == 'training-center-group-change') {
          this.fetchTcsForTCG(newValue)
            .then(resp => {

              // let x = new SerializedResponse(TrainingCenter, resp.data)

              GlobalEventBus.dispatch(this.raiseOnChange, resp.data)
              GlobalEventBus.dispatch('paul-clear', true)
            })
        }
      },
      getNewOptions(type, newValue) {
        console.log("type", type)
        console.log("newValue", newValue)

        if (type == "person-change") {
          let count = 1
          this.listOptions = newValue.map(country => {
            let data = {
              id: country.id,
              tracking_id: count,
              name: country.attributes.name,
              restricted: country.attributes.restricted,
            }
    
            count++
    
            return data
          })
        } else if (type == "country-change") {
          let count = 1
          this.listOptions = newValue.map(tcg => {
            let data = {
              id: tcg.id,
              tracking_id: count,
              name: tcg.name,
            }

            count++

            return data
          })
          
        } else if (type == "training-center-group-change") {
          let count = 1

          this.listOptions = newValue.data.map(tc => {
            let data = {
              id: tc.relationships.current_paul.data.id,
              tracking_id: count,
              name: tc.attributes.name,
              training_center_id: tc.attributes.id,
              training_center_group_id: tc.attributes.training_center_group_id,
            }
    
            count++
    
            return data
          })
        } else {

        }
      },
      fetchLeadersForCountry(country) {
        return axios.get(`/users.json`, {
          params: {
            country_id: country.id,
            user_roles: ['field_rep_manage'],
            fetching_task_leaders: true
          }
        }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          }
        })
      },
      fetchTcgsForCountry(country) {
        console.log('country', country)
        let params = this.extraParams ? this.extraParams : {}
        params.country_id = country.id
        params.state = 'active'
        console.log('params', params)

        return axios.get(`/training_center_groups.json`, {
            params: params
        }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          }
        })
      },
      fetchTcsForTCG(trainingCenterGroup) {
        let params = this.extraParams ? this.extraParams : {}
        params.training_center_group_id = trainingCenterGroup.id
        params.state = 'available'
        console.log('getting tcs for tcg', trainingCenterGroup)
        console.log('params', params)
        return axios.get(`/training_centers.json`, { params: params }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          }
        })
      },
      fetchCountriesForPerson(person_id) {
        return axios.get(`/countries.json`, {
          params: {
            person_id: person_id,
            has_person_role_type_in: 'leader'
          }
        }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          }
        })
      },
      fetchTimothies(paul) {
        if (paul) {
          axios.get(`/fetch_timothies.json`, {
            params: {
              paul_id: paul.id
            }
          }, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
          })
          .then(response => {
            let numTims = document.getElementById('num-tims')
            numTims.value = response.data.length
            numTims.disabled = true

            let stringifiedList = response.data.map(x => x.name).join(',')

            let hiddenregisteredTims = document.getElementById('hidden-registered-tims')
            hiddenregisteredTims.value = numTims.value

            console.log('gon.tims_present', gon.tims_present)
            console.log('stringifiedList', stringifiedList)

            this.setUpTimothyCheckBoxes(stringifiedList) 
            this.setUpTimothyHiddenFieldForCreate()

            return response
          }, error => {
            console.log('error when fetching timothies', error)
          })
        }
      },
      fetchReport(newValue) {
        if (newValue) {
          axios.get(`/fetch_report.json`, {
            params: {
              training_center_id: newValue.training_center_id
            }
          }, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
          })
          .then(response => {
  
            if (response.data.no_report) {
              return false
            }
  
            let timChurchesLabel = document.getElementById("report-num-tim-churches")
            timChurchesLabel.innerHTML = `Reported ${response.data.validated_at}: ${response.data.num_churches1}`
  
            let titusChurchesLabel = document.getElementById("report-num-titus-churches")
            titusChurchesLabel.innerHTML = `Reported ${response.data.validated_at}: ${response.data.num_churches2}`
  
            let titusDisChurchesLabel = document.getElementById("report-num-titus-dis-churches")
            titusDisChurchesLabel.innerHTML = `Reported ${response.data.validated_at}: ${response.data.num_churches3}`
  
            let newBelieversLabel = document.getElementById("report-num-new-believers")
            newBelieversLabel.innerHTML = `Reported (${response.data.validated_at}): ${response.data.num_salvations}`
  
            let baptismsLabel = document.getElementById("report-num-baptisms")
            baptismsLabel.innerHTML = `Reported ${response.data.validated_at}: ${response.data.num_baptisms}`
  
            let orphansLabel = document.getElementById("report-num-orphans")
            orphansLabel.innerHTML = `Reported ${response.data.validated_at}: ${response.data.num_orphans_served}`
  
            let widowsLabel = document.getElementById("report-num-widows")
            widowsLabel.innerHTML = `Reported ${response.data.validated_at}: ${response.data.num_widows_served}`
  
            return response
          }, error => {
            console.log('error when fetching latest tc report', error)
          })
        }
      },
      setUpTimothyCheckBoxes(stringifiedList) {
        let timArray = stringifiedList.split(',')
        let timCheckBoxContainer = document.getElementById('tim-checkbox-container')

        if (timArray[0] != '') {
          while (timCheckBoxContainer.firstChild) {
            timCheckBoxContainer.firstChild.remove()
          }
          
          timArray.forEach(tim => {
            let label = document.createElement('label')
            label.style.display = 'flex'
            label.style.paddingBottom = '.5rem'

            let checkbox = document.createElement('input')
            checkbox.style.marginRight = '.5rem'
            checkbox.type = 'checkbox'
            checkbox.id = `tim-${tim}`

            let labelDiv = document.createElement('div')
            labelDiv.innerHTML = tim
            
            if (document.getElementById('temp-textarea')) {
              document.getElementById('temp-textarea').style.display = 'none'
            }

            label.appendChild(checkbox)
            label.appendChild(labelDiv)
            timCheckBoxContainer.appendChild(label)
          })
        } else {

          while (timCheckBoxContainer.firstChild) {
            timCheckBoxContainer.firstChild.remove()
          }

          let noTimsElem = document.createElement('input')
          noTimsElem.value = "N/A"
          noTimsElem.disabled = true

          if (document.getElementById('temp-textarea')) {
            document.getElementById('temp-textarea').style.display = 'none'
          }

          timCheckBoxContainer.appendChild(noTimsElem)
        }
      },
      setUpTimothyHiddenFieldForCreate() {
        var timsArray = []

        if (gon.tims_present) {
          timsArray = gon.tims_present
        }

        var container = document.querySelector('#tim-checkbox-container')
        var checkboxesAll = container.querySelectorAll('input[type="checkbox"]')
        // var checkBoxesSelected = container.querySelectorAll('input[type="checkbox"]:checked')

        let timsPresentHiddenField = document.getElementById('tims-present-hidden')

        console.log("first", timsPresentHiddenField.value, timsArray)

        checkboxesAll.forEach(checkbox => {
          checkbox.addEventListener('click', function () {

            if(checkbox.checked) {
              console.log("checked")
              timsArray.push(checkbox.id.slice(4))
            } else {
              console.log("not checked")
              timsArray.splice(timsArray.indexOf(checkbox.id.slice(4)), 1)
            }

            timsPresentHiddenField.value = timsArray

            console.log("Ajnrkednne", timsPresentHiddenField.value, timsArray)
          })
        })
      },      
      getTCVisits(value) {
        console.log(`getting training center visits for ${value}`)

        axios.get(`/field_rep_visits.json`, {
          params: {
            visitable_id: value,
            visit_type: 'TrainingCenter' // controller uses visit_type not visitable_type as param name
          }
        }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          }
        })
        .then(response => {
          let previousVisits = []
          let visits = response.data
          visits.forEach(v => { 
            let vDate = new Date(v.visited_at)
            previousVisits.push({visited_on: vDate.toLocaleDateString(), visited_by: v.person_name})

          })
          if (previousVisits.length > 2){
            ModalService.spawn('duplicate-visit-warning', { title: 'warning', type: 'training-center-visit', previous_items: previousVisits })
            let dupe = document.getElementById('hidden-possible-dupe')
            if (dupe) { dupe.value = true }
          }
        })
      }

    },
    props: {
      options: {
        type: String,
        required: true,
      },
      optionsSource: {
        type: String,
        required: false,
      },
      value: {
        type: Object,
        required: false,
      },
      labelName: {
        type: String,
        required: false,
      },
      valueName: {
        type: String,
        required: false,
      },
      hiddenElement: {
        type: String,
        required: true,
      },
      listenFor: {
        type: String,
        required: false,
      },
      raiseOnChange: {
        type: String,
        required: false,
      },
      toClear: {
        type: String,
        required: false,
      },
      formType: {
        type: String,
        required: false,
      },
      extraParams: {
        type: Object,
        required: false,
      },
    },
    watch: {
      selectedOption (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.setNewValue(newVal)
        }
      },
    },
  }
</script>

<style lang="scss">
  .multiselector {
    min-width: 14rem;
    max-width: 100%;
  }
</style>
